import {
  types,
  IGetLanguagesStartedAction,
  IGetLanguagesSuccessAction,
  IFailureAction,
  IGetLanguagesCancelAction,
} from '../types/languages'

export const getLanguages = (): IGetLanguagesStartedAction => ({
  type: types.GET_LANGUAGES__STARTED,
})

export const getLanguagesSuccess = (
  list: Array<{
    code: string
    title: string
  }>
): IGetLanguagesSuccessAction => ({
  type: types.GET_LANGUAGES__SUCCESS,
  list: list.map(({ code: value, title: label }) => ({ value, label })),
})

export const getLanguagesFailure = (message: string): IFailureAction => ({
  type: types.GET_LANGUAGES__FAILURE,
  message,
})

export const getLanguagesCancel = (): IGetLanguagesCancelAction => ({
  type: types.GET_LANGUAGES__CANCEL,
})
